import { FC, ReactElement } from 'react'

import { useI18n } from '../../hooks'
import RedirectionTimer from '../redirectionTimer'

import './index.css'

type RedirectionModalProps = {
  timerStartTime: number
  thirdPartyWebsiteAddress: string
  thirdPartyWebsiteName: string
  onRedirect: () => void
}

const RedirectionModal: FC<RedirectionModalProps> = (props): ReactElement => {
  const { timerStartTime, thirdPartyWebsiteAddress, onRedirect } = props

  const redirectFunction = () => {
    window.open(thirdPartyWebsiteAddress, '_blank', 'noopener,noreferrer')
    onRedirect()
  }

  const { t } = useI18n()

  return (
    <div className="redirection-modal-container">
      <header className="redirection-modal-header heavy">{t('RedirectionModal_autoNavigating')} ...</header>
      <hr className="redirection-modal-separator" />
      <section className="redirection-info-section">
        <div className="redirection-modal-timer heavy">
          <RedirectionTimer startTime={timerStartTime} callBackFunction={redirectFunction} />
        </div>
        <div className="redirection-modal-info-content">{t('RedirectionModal_redirectionInfoDescription')}</div>
      </section>
    </div>
  )
}

export default RedirectionModal
